/* Toast globale — replica di sonner 1.7.0 come configurato nell'headless
   (`<Toaster position="top-center" toastOptions={{duration: 2000}} />`,
   layouts/page.tsx:118). Valori MISURATI sul live (tools/pixel-diff/measure-toast.mjs):
   - contenitore fixed top 32px, left 50% translateX(-50%), width 356px, z 999999999
   - toast bg #fff, border 1px #ededed, radius 8, shadow 0 4px 12px rgba(0,0,0,.1),
     padding 16, gap 6, font 13px/19.5 500, colore #171717, altezza 53.5 con una riga
   - icona = heroicons check-circle solid 20×20 fill currentColor (NERA: sonner ha
     richColors OFF, quindi NON è il check verde)
   - enter: opacity 0→1 + translateY(-100%)→0 in 400ms ease
   - exit dopo 2000ms: opacity 1→0 + translateY(0)→-100% in 400ms ease
   - <600px: left/right 16px, width calc(100% - 32px), top 20px, senza translate

   API: window.ivToast('messaggio')  (usata da PDP, card, carrello, drawer). */

(function () {
  'use strict';

  var DURATION = 2000;
  var ANIM = 400;
  var ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" height="20" width="20">' +
    '<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"></path></svg>';

  var toaster = null;
  var current = null;
  var timers = [];

  function clearTimers() {
    timers.forEach(clearTimeout);
    timers = [];
  }

  function ensureToaster() {
    if (toaster && document.body.contains(toaster)) return toaster;
    toaster = document.createElement('ol');
    toaster.className = 'iv-toaster';
    toaster.setAttribute('dir', 'ltr');
    toaster.setAttribute('tabindex', '-1');
    toaster.setAttribute('aria-live', 'polite');
    document.body.appendChild(toaster);
    return toaster;
  }

  function remove(el) {
    if (!el) return;
    el.classList.add('is-removed');
    timers.push(
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
        if (current === el) current = null;
      }, ANIM)
    );
  }

  window.ivToast = function (message) {
    if (!message) return;
    var host = ensureToaster();
    clearTimers();

    // Sonner impila i toast; nell'uso del sito ne compare uno per volta
    // (add-to-cart / rimozione riga): riuso il nodo aggiornando il testo,
    // così il timer riparte come farebbe un nuovo toast.
    if (current && current.parentNode) {
      current.querySelector('.iv-toast__title').textContent = message;
      current.classList.remove('is-removed');
      timers.push(
        setTimeout(function () {
          remove(current);
        }, DURATION)
      );
      return;
    }

    var li = document.createElement('li');
    li.className = 'iv-toast';
    li.setAttribute('tabindex', '0');
    li.innerHTML =
      '<div class="iv-toast__icon">' +
      ICON +
      '</div><div class="iv-toast__content"><div class="iv-toast__title"></div></div>';
    li.querySelector('.iv-toast__title').textContent = message;
    host.appendChild(li);
    current = li;

    // frame successivo: parte la transizione di entrata
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        li.classList.add('is-mounted');
      });
    });

    timers.push(
      setTimeout(function () {
        remove(li);
      }, DURATION)
    );
  };
})();
